import React from 'react';
import { ExternalLinkIcon, FileTextIcon, FolderIcon, Music2Icon, PlayCircleIcon } from 'lucide-react';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { Waves } from '../ui/Logo';
import { materialGroups, recentFiles } from '../../data/materials';
import { useApp } from '../../contexts/AppContext';
const icons = {
  note: Music2Icon,
  posnetki: PlayCircleIcon,
  dokumenti: FileTextIcon,
  drive: FolderIcon
};
export function MaterialsPanel() {
  const {
    settings
  } = useApp();
  return <div className="space-y-4" data-id="element-327" data-mp="208oipin1g5s9">
      <Card className="relative overflow-hidden" data-id="element-328" data-mp="209gg8z074dl6">
        <Waves className="pointer-events-none absolute -right-6 top-2 h-24 w-64" opacity={0.1} data-id="element-329" data-mp="2e7xvs9fy6js0" />
        <div className="relative flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-330" data-mp="2a48b3v2e8mc9">
          <div data-id="element-331" data-mp="3pkqn5j4tt67j">
            <div className="flex items-center gap-2" data-id="element-332" data-mp="3pk8ipz80floj">
              <FolderIcon className="h-5 w-5 text-green-600" data-id="element-333" data-mp="3lkzqiysmbvv3" />
              <h2 className="text-base font-semibold text-ink" data-id="element-334" data-mp="3lmsxkf758i3m">Google Drive mapa zbora</h2>
            </div>
            <p className="mt-1.5 max-w-xl text-sm leading-relaxed text-ink-muted" data-id="element-335" data-mp="p5zx8t5bbvr3">
              Vsa gradiva zbora — note, posnetki in interni dokumenti — so shranjena v skupni Google Drive
              mapi. Dostop imajo vsi člani zbora s svojim zborovskim e-naslovom.
            </p>
          </div>
          <a href={settings.driveLink} target="_blank" rel="noreferrer" className="inline-flex shrink-0 items-center justify-center gap-2 rounded-lg border border-green-500 bg-green-500 px-4 py-2.5 text-sm font-medium text-white transition-colors duration-150 ease-out hover:bg-green-600" data-id="element-336" data-mp="1gfeaa95syht">
            Odpri mapo
            <ExternalLinkIcon className="h-4 w-4" data-id="element-337" data-mp="f9512gwii7fz" />
          </a>
        </div>
      </Card>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-338" data-mp="3dxasv2lo8fz9">
        {materialGroups.map(g => {
        const Icon = icons[g.icon];
        return <a key={g.id} href={g.link} target="_blank" rel="noreferrer" className="flex flex-col rounded-xl border border-line bg-white p-5 shadow-card transition-colors duration-150 ease-out hover:border-green-200 hover:bg-green-50/30" data-id="element-339" data-mp="q1narbdyixut">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-canvas" data-id="element-340" data-mp="uugd5slydu3q">
                <Icon className="h-5 w-5 text-green-600" data-id="element-341" data-mp="74dprpszhcbg" />
              </span>
              <span className="mt-3 text-sm font-semibold text-ink" data-id="element-342" data-mp="259jb6xg1sot">{g.naslov}</span>
              <span className="mt-1 flex-1 text-[13px] leading-relaxed text-ink-muted" data-id="element-343" data-mp="g4sd0upid1hl">{g.opis}</span>
              <span className="mt-3 flex items-center justify-between" data-id="element-344" data-mp="b4o53t2o1f2z">
                <Badge className="bg-canvas text-ink-muted border-line" data-id="element-345" data-mp="b7in7dy7int8">{g.stevilo}</Badge>
                <ExternalLinkIcon className="h-4 w-4 text-ink-muted" data-id="element-346" data-mp="1rl8wr083i4a9" />
              </span>
            </a>;
      })}
      </div>

      <Card className="p-5" data-id="element-347" data-mp="1v13pc0ku9ikt">
        <h2 className="text-base font-semibold text-ink" data-id="element-348" data-mp="1uzs9v3i16mdv">Nazadnje dodano</h2>
        <ul className="mt-3 divide-y divide-line" data-id="element-349" data-mp="1z3700mzooj51">
          {recentFiles.map(f => <li key={f.id} className="flex items-center gap-3 py-3" data-id="element-350" data-mp="1l3z0fszlz90b">
              <FileTextIcon className="h-4 w-4 shrink-0 text-ink-muted" data-id="element-351" data-mp="1q28w04p8wbmg" />
              <span className="min-w-0 flex-1 truncate text-sm text-ink" data-id="element-352" data-mp="1q2in5vm10otq">{f.ime}</span>
              <Badge className="hidden bg-canvas text-ink-muted border-line sm:inline-flex" data-id="element-353" data-mp="2dscy27msc3bc">{f.skupina}</Badge>
              <span className="shrink-0 text-[13px] text-ink-muted" data-id="element-354" data-mp="2iq4o0w3vdfcw">{f.dodano}</span>
            </li>)}
        </ul>
      </Card>
    </div>;
}